import { createApp } from 'vue'
import UnassignedSubstudies from '../components/participants/UnassignedSubstudy.vue';

// Substudy detail
if (document.getElementById('participant-substudies')) {
    const substudyDetailVue = createApp({})
    substudyDetailVue.component('UnassignedSubstudies', UnassignedSubstudies)
    substudyDetailVue.mount('#participant-substudies')
}

if (document.getElementById('participant-info')) {
    const substudyDetailVue = createApp({})
    substudyDetailVue.component('UnassignedSubstudies', UnassignedSubstudies)
    substudyDetailVue.mount('#participant-info')
}